
define('text!modules/shared/templates/searchBox.html',[],function () { return '<div class="w-InfiniteScrollSearchBox">\n</div>';});

